<template>
  <div class="panel panel-primary">
    <div class="panel-heading PanelHeadingCaption roundedcornerdiv">Applicant Information</div>
    <div class="panel-body">
      <div class="row Q_Row">
        <div class="col">
          <fieldset class="form-group">
            <label class="Questionniare_Label">First name</label>
            <input
              id="inputApplicant_FirstName"
              type="text"
              v-model="$v.CommonQuestions.Applicant_FirstName.$model"
              class="form-control form-control-lg"
              :class="{ 'error': $v.CommonQuestions.Applicant_FirstName.$invalid && this.CommonQuestions.Common_Questionnaire_Submitted }"
              maxlength="20"
              placeholder="John"
            />
          </fieldset>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col">
          <fieldset class="form-group">
            <label class="Questionniare_Label">Last Name</label>
            <input
              id="inputApplicant_LastName"
              type="text"
              v-model="$v.CommonQuestions.Applicant_LastName.$model"
              class="form-control form-control-lg"
              :class="{ 'error': $v.CommonQuestions.Applicant_LastName.$invalid && this.CommonQuestions.Common_Questionnaire_Submitted }"
              maxlength="35"
              placeholder="Doe"
            />
          </fieldset>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col">
          <fieldset class="form-group">
            <label class="Questionniare_Label">Telephone Number</label>
            <input
              id="inputTelephone"
              class="form-control form-control-lg"
              :class="{ 'error': $v.CommonQuestions.Applicant_TelephoneNumber.$invalid &&  this.CommonQuestions.Common_Questionnaire_Submitted }"
              type="text"
              v-mask="'###-###-####'"
              v-model="$v.CommonQuestions.Applicant_TelephoneNumber.$model"
              placeholder="555-555-5555"
            />
          </fieldset>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col">
          <fieldset class="form-group">
            <label class="Questionniare_Label">Address 1 of 2</label>
            <input
              class="form-control form-control-lg"
              :class="{ 'error': $v.CommonQuestions.Applicant_Address1.$invalid && this.CommonQuestions.Common_Questionnaire_Submitted }"
              type="text"
              v-model="$v.CommonQuestions.Applicant_Address1.$model"
              maxlength="30"
              placeholder="123 Main St."
            />
          </fieldset>
        </div>
      </div>
      <div class="row Q_Row">
        <div class="col">
          <fieldset class="form-group">
            <label class="Questionniare_Label">Address 2 of 2</label>
            <input
              class="form-control form-control-lg"
              type="text"
              v-model="$v.CommonQuestions.Applicant_Address2"
              maxlength="30"
              placeholder
            />
          </fieldset>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col-sm-4">
          <fieldset class="form-group">
            <label class="Questionniare_Label">Zip Code</label>
            <input
              class="form-control form-control-lg"
              :class="{ 'error': $v.CommonQuestions.Applicant_ZipCode.$invalid && this.CommonQuestions.Common_Questionnaire_Submitted }"
              type="text"
              v-mask="'#####'"
              v-model="$v.CommonQuestions.Applicant_ZipCode.$model"
              placeholder="99999"
            />
          </fieldset>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col">
          <fieldset class="form-group">
            <label class="Questionniare_Label">City</label>
            <input
              class="form-control form-control-lg"
              :class="{ 'error': $v.CommonQuestions.Applicant_City.$invalid && this.CommonQuestions.Common_Questionnaire_Submitted }"
              type="text"
              v-model="$v.CommonQuestions.Applicant_City.$model"
              maxlength="25"
              placeholder="Anytown"
            />
          </fieldset>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col">
          <fieldset class="form-group">
            <label class="Questionniare_Label">State:</label>
            <select
              v-model="$v.CommonQuestions.Applicant_State.$model"
              class="statedropdown form-control form-control-lg"
              :class="{ 'error': $v.CommonQuestions.Applicant_State.$invalid  &&  this.CommonQuestions.Common_Questionnaire_Submitted }"
            >
              <option value="AL">Alabama</option>
              <option value="AK">Alaska</option>
              <option value="AZ">Arizona</option>
              <option value="AR">Arkansas</option>
              <option value="CA">California</option>
              <option value="CO">Colorado</option>
              <option value="CT">Connecticut</option>
              <option value="DE">Delaware</option>
              <option value="DC">District Of Columbia</option>
              <option value="FL">Florida</option>
              <option value="GA">Georgia</option>
              <option value="HI">Hawaii</option>
              <option value="ID">Idaho</option>
              <option value="IL">Illinois</option>
              <option value="IN">Indiana</option>
              <option value="IA">Iowa</option>
              <option value="KS">Kansas</option>
              <option value="KY">Kentucky</option>
              <option value="LA">Louisiana</option>
              <option value="ME">Maine</option>
              <option value="MD">Maryland</option>
              <option value="MA">Massachusetts</option>
              <option value="MI">Michigan</option>
              <option value="MN">Minnesota</option>
              <option value="MS">Mississippi</option>
              <option value="MO">Missouri</option>
              <option value="MT">Montana</option>
              <option value="NE">Nebraska</option>
              <option value="NV">Nevada</option>
              <option value="NH">New Hampshire</option>
              <option value="NJ">New Jersey</option>
              <option value="NM">New Mexico</option>
              <option value="NY">New York</option>
              <option value="NC">North Carolina</option>
              <option value="ND">North Dakota</option>
              <option value="OH">Ohio</option>
              <option value="OK">Oklahoma</option>
              <option value="OR">Oregon</option>
              <option value="PA">Pennsylvania</option>
              <option value="RI">Rhode Island</option>
              <option value="SC">South Carolina</option>
              <option value="SD">South Dakota</option>
              <option value="TN">Tennessee</option>
              <option value="TX">Texas</option>
              <option value="UT">Utah</option>
              <option value="VT">Vermont</option>
              <option value="VA">Virginia</option>
              <option value="WA">Washington</option>
              <option value="WV">West Virginia</option>
              <option value="WI">Wisconsin</option>
              <option value="WY">Wyoming</option>
            </select>
          </fieldset>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col">
          <fieldset class="form-group">
            <label class="Questionniare_Label">Email Address</label>
            <input
              class="form-control form-control-lg"
              :class="{ 'error': $v.CommonQuestions.Applicant_EmailAddress.$invalid && this.CommonQuestions.Common_Questionnaire_Submitted }"
              type="text"
              v-model="$v.CommonQuestions.Applicant_EmailAddress.$model"
              maxlength="100"
              placeholder="MyName@Gmail.com"
            />
          </fieldset>
        </div>
      </div>

      <div class="row Q_Row">
        <div class="col">
          <fieldset class="form-group">
            <label class="Questionniare_Label">Confirm Email</label>
            <input
              class="form-control form-control-lg"
              :class="{ 'error': $v.CommonQuestions.Applicant_ConfirmationEmailAddress.$invalid && this.CommonQuestions.Common_Questionnaire_Submitted }"
              type="text"
              v-model="$v.CommonQuestions.Applicant_ConfirmationEmailAddress.$model"
              maxlength="100"
              placeholder="MyName@Gmail.com"
            />
          </fieldset>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import VueMask from "v-mask";
import axios from "axios";

import {
  required,
  requiredIf,
  decimal,
  minValue,
  minLength,
  email,
  sameAs
} from "vuelidate/lib/validators";

export default {
  props: {
    CommonQuestions: {
      type: Object,
      required: true
    },
    v: {
      type: Object,
      required: true
    },
    CorpCode: {
      type: String,
      required: true
    }
  },
  watch: {
    "$v.CommonQuestions.Applicant_ZipCode.$model": function(val, preVal) {
      if (val.length == 5) {

       axios
          .get(process.env.VUE_APP_API_URL + "ZipCode?ZipCode=" + val + "&CorpCode=" + this.CorpCode)
          .then(response => {
            this.CommonQuestions.Applicant_State = response.data[0].state;
            this.CommonQuestions.Applicant_City = response.data[0].city;
          })
          .catch(e => {
            //console.log(e);
          });
      }
    }
  },
  validations: {
    CommonQuestions: {
      Applicant_FirstName: {
        required
      },
      Applicant_LastName: {
        required
      },
      Applicant_TelephoneNumber: {
        required,
        minLength: minLength(12)
      },
      Applicant_EmailAddress: {
        required
      },
      Applicant_ConfirmationEmailAddress: {
        required,
        sameAsPassword: sameAs("Applicant_EmailAddress")
      },
      Applicant_Address1: {
        required
      },
      Applicant_City: {
        required
      },
      Applicant_State: {
        required
      },
      Applicant_ZipCode: {
        required
      }
    }
  }
};
</script>
